export const socialsData = {
    github: 'https://github.com/AshrakShohas',
    facebook: 'https://www.facebook.com/ashrak.shohas.3',
    linkedIn: 'https://www.linkedin.com/in/ashrak-shohas-901771166/?fbclid=IwAR2EntUIq3Nu2d4vlTBwHcTG0MnXDQ942ZG_7hbyRBhRD942vrcHLK1FRiI',
    // instagram: 'https://www.instagram.com/',
    // codepen: 'https://codepen.io/',
    // twitter: 'https://twitter.com/',
    // reddit: 'https://www.reddit.com/user/',
    // blogger: 'https://www.blogger.com/',
    medium: 'https://evilarif97.medium.com/',
    // stackOverflow: 'https://stackoverflow.com/users/',
    // gitlab: 'https://gitlab.com/',
    // youtube: 'https://youtube.com/'
}